import { render, staticRenderFns } from "./registration.vue?vue&type=template&id=72853987&scoped=true"
import script from "./registration.vue?vue&type=script&lang=ts"
export * from "./registration.vue?vue&type=script&lang=ts"
import style0 from "./registration.vue?vue&type=style&index=0&id=72853987&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72853987",
  null
  
)

export default component.exports